import { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FullscreenStatus } from "@/components/layout/FullscreenStatus";
import { useAuthStore } from "@/stores/authStore";

export function AdminRoute() {
  const { t } = useTranslation();
  const location = useLocation();
  const authStatus = useAuthStore((state) => state.authStatus);
  const isHydrated = useAuthStore((state) => state.isHydrated);
  const isAdmin = useAuthStore((state) => state.isAdmin);
  const profileStatus = useAuthStore((state) => state.profileStatus);
  const refreshProfile = useAuthStore((state) => state.refreshProfile);
  const [lastValidatedPath, setLastValidatedPath] = useState<string | null>(null);

  useEffect(() => {
    let isActive = true;

    if (!isHydrated || authStatus !== "authenticated") {
      setLastValidatedPath(location.pathname);
      return () => {
        isActive = false;
      };
    }

    setLastValidatedPath(null);
    void refreshProfile().finally(() => {
      if (isActive) {
        setLastValidatedPath(location.pathname);
      }
    });

    return () => {
      isActive = false;
    };
  }, [authStatus, isHydrated, location.pathname, refreshProfile]);

  const isRevalidatingAdminAccess = authStatus === "authenticated"
    && lastValidatedPath !== location.pathname;

  if (
    !isHydrated
    || authStatus === "idle"
    || authStatus === "loading"
    || (authStatus === "authenticated" && profileStatus === "loading")
    || isRevalidatingAdminAccess
  ) {
    return <FullscreenStatus title={t("common.loading")} />;
  }

  if (!isAdmin) {
    return <Navigate replace to="/app" />;
  }

  return <Outlet />;
}
